import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
export function PainPointsSection() {
  const painPoints = [{
    emoji: '😩',
    title: 'Las mañanas son una guerra',
    description: 'Gritos, corridas, ropa perdida y el corazón a mil. Y todavía no son las 8am.'
  }, {
    emoji: '📚',
    title: 'Las tareas escolares te agotan',
    description: '"No entiendo nada" + tu cansancio + la presión del tiempo = explosión garantizada.'
  }, {
    emoji: '😔',
    title: 'Vos sos la última de tu lista',
    description: 'Todos tienen su tiempo menos vos. Y cuando querés parar, la culpa aparece.'
  }, {
    emoji: '🌪️',
    title: 'Un imprevisto y todo se cae',
    description: 'Sin sistema, cualquier cambio de planes te desestabiliza por completo.'
  }, {
    emoji: '🌙',
    title: 'Las noches son tu tribunal interno',
    description: 'Cuando todos duermen, tu mente repasa todo lo que no hiciste. Siempre.'
  }];
  return <section id="el-problema" className="py-20 md:py-28 bg-cream relative overflow-hidden" data-id="element-168">
      {/* Decorative background elements */}
      <div className="absolute top-12 right-12 opacity-40" data-id="element-169">
        <SparkleDecoration size={44} color="#E8735A" type="star" data-id="element-170" />
      </div>
      <div className="absolute bottom-16 left-8 opacity-30" data-id="element-171">
        <SparkleDecoration size={36} color="#F2A59D" data-id="element-172" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        {/* Headline */}
        <AnimatedSection className="text-center mb-14 md:mb-18 relative" data-id="element-174">
          <div className="inline-block relative" data-id="element-175">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-burgundy leading-tight" data-id="element-176">
              Reconocé las señales antes de llegar al límite
            </h2>
            <div className="absolute -top-5 -right-6 md:-top-7 md:-right-10" data-id="element-177">
              <SparkleDecoration size={28} color="#E8735A" type="star" data-id="element-178" />
            </div>
          </div>
        </AnimatedSection>

        {/* Pain Point Cards — stacked, full-width, alternating colors */}
        <div className="flex flex-col gap-5" data-id="element-179">
          {painPoints.map((point, index) => {
          const colorSchemes = [{
            bg: 'bg-coral',
            title: 'text-white',
            desc: 'text-white/80',
            border: 'border-coral'
          }, {
            bg: 'bg-rose/30',
            title: 'text-burgundy',
            desc: 'text-burgundy/70',
            border: 'border-rose/40'
          }, {
            bg: 'bg-burgundy',
            title: 'text-white',
            desc: 'text-white/80',
            border: 'border-burgundy'
          }, {
            bg: 'bg-coral',
            title: 'text-white',
            desc: 'text-white/80',
            border: 'border-coral'
          }, {
            bg: 'bg-rose/30',
            title: 'text-burgundy',
            desc: 'text-burgundy/70',
            border: 'border-rose/40'
          }];
          const scheme = colorSchemes[index];
          return <AnimatedSection key={index} delay={index * 0.1} data-id="element-180">
                <div className={`${scheme.bg} ${scheme.border} border rounded-xl p-4 md:p-5 card-relief flex items-start gap-3 md:gap-4 transition-all duration-300 hover:scale-[1.01] cursor-pointer`} data-id="element-181">
                  {/* Emoji */}
                  <span className="text-2xl md:text-3xl flex-shrink-0 mt-0.5" data-id="element-182">
                    {point.emoji}
                  </span>

                  {/* Text content */}
                  <div className="flex flex-col gap-1" data-id="element-183">
                    <h3 className={`text-sm md:text-base font-serif font-bold leading-snug ${scheme.title}`} data-id="element-184">
                      {point.title}
                    </h3>
                    <p className={`text-xs md:text-sm leading-relaxed ${scheme.desc}`} data-id="element-185">
                      {point.description}
                    </p>
                  </div>
                </div>
              </AnimatedSection>;
        })}
        </div>

        {/* Closing line */}
        <AnimatedSection delay={0.6} className="mt-14 md:mt-18 text-center" data-id="element-186">
          <p className="text-xl md:text-2xl font-serif font-bold text-burgundy leading-snug max-w-2xl mx-auto" data-id="element-187">
            Esto no es agotamiento normal.{' '}
            <span className="text-coral" data-id="element-188">Es falta de sistema.</span> Y eso tiene
            solución.
          </p>
        </AnimatedSection>

        {/* CTA */}
        <AnimatedSection delay={0.75} className="mt-10 text-center" data-id="element-189">
          <a href="#precio" className="inline-block bg-emerald-500 text-white px-10 py-4 rounded-full font-bold text-base md:text-lg hover:scale-105 transition-transform duration-300 shadow-xl" data-id="element-190">
            Quiero el sistema que lo resuelve
          </a>
        </AnimatedSection>
      </div>
    </section>;
}